<!-- Divider -->
<div
    class="hippo-vertical-navigation-item-wrapper divider"
    [ngClass]="$safeNavigationMigration(item.classes?.wrapper)"></div>
